module.exports = __webpack_public_path__ + "static/media/SV1_04_NoHarm_1000.67459626.jpg";